import ReactController from '~/controllers/react_controller'
import AzureDashboardCharts from '~/dashboard/azure_dashboard_charts'

export default class AzureDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
    defaultTab: String,
  }

  createComponent() {
    return <AzureDashboardCharts organizationId={this.organizationIdValue} defaultTab={this.defaultTabValue} />
  }
}
